import 'twin.macro'

import Button from 'components/UI/Buttons/Button'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useTimer } from 'react-timer-hook'
import { ApplicationEvents } from 'share/enums/events'
import Emitter from 'utils/emitter'

const RetryTimer = ({ timestamp }: { timestamp: Date }) => {
  // Tools
  const { t } = useTranslation()

  // Hooks
  const { seconds, minutes, hours, isRunning } = useTimer({
    expiryTimestamp: timestamp
  })

  // Handler
  const handleStepRetry = async () => {
    Emitter.emit(ApplicationEvents.NAVIGATE_TO_NEXT_PAGE)
  }

  return (
    <Fragment>
      <p tw='text-s18 leading-s18 tracking-[-0.15px] text-primary mt-2 mb-9 md:mb-32'>{`${hours ? hours + ':' : ''}${
        minutes < 10 ? '0' + minutes : minutes
      }:${seconds < 10 ? '0' + seconds : seconds}`}</p>
      <Button variant='secondary' disabled={isRunning} onClick={handleStepRetry}>
        {t('flow-retry')}
      </Button>
    </Fragment>
  )
}

export default RetryTimer
